export const DATALAB_EXERCISE = 'DatalabExercise';
export const EXPORTED_EXERCISES = [DATALAB_EXERCISE];